import React, { Component } from "react";
import moment from "moment";
import { DscPlan, NombreCliente, NombreRamo } from "../../coms/BlkGenerales";
import { ModalPrint } from "./ModalPrint";
import Alerts from "../../util/Alerts";

export class Contratante extends Component {
    constructor(props) {
        super(...arguments);
        this.alert = React.createRef();
        this.state = {
            open: false,
            pdf: false,
            aseg: false,
        };
    }

    closeModal = val => {
        this.setState({ open: val, pdf: false, aseg: false });
    };

    render() {
        let { poliza, item, user, vida } = this.props;

        return (
            <div className="col-lg-3 bg-primary pd-lateral pt-2 pt-md-5">
                <Alerts ref={this.alert} />
                <table className="m-auto text-left fs12 line-height-normal">
                    <tbody>
                        <tr>
                            <td>
                                <span className="font-weight-bolder text-primary">Contratante:</span>
                                <br />
                                <NombreCliente
                                    cod={poliza.cdCliente || item.cdCliente || poliza?.cotizacion?.cdCliente}
                                />
                            </td>
                        </tr>
                        <tr></tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Aseguradora:</td>
                        </tr>
                        <tr>
                            <td>{poliza.cotizacion.aseguradora.nmAseguradora}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Ramo:</td>
                        </tr>
                        <tr>
                            <td>{<NombreRamo cod={poliza.cdRamo} list={this.props.ramos} />}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Póliza:</td>
                        </tr>
                        <tr>
                            <td>{poliza.poliza}</td>
                        </tr>
                        {vida ? (
                            <>
                                <tr>
                                    <td className="font-weight-bolder text-primary">Plan:</td>
                                </tr>
                                <tr>
                                    <td className="text-uppercase">{<DscPlan cod={item.cdUbicacion} />}</td>
                                </tr>
                            </>
                        ) : (
                            <>
                                <tr>
                                    <td className="font-weight-bolder text-primary">Tipo:</td>
                                </tr>
                                <tr>
                                    <td className="text-uppercase">{item.tipo}</td>
                                </tr>
                                <tr>
                                    <td className="font-weight-bolder text-primary">Anexo:</td>
                                </tr>
                                <tr>
                                    <td className="text-uppercase">{item.anexo}</td>
                                </tr>
                            </>
                        )}
                        <tr>
                            <td className="font-weight-bolder text-primary">Fc Desde:</td>
                        </tr>
                        <tr>
                            <td className="text-uppercase">
                                {poliza.fcDesde
                                    ? moment(poliza.fcDesde).locale("moment/locale/es").local().format("DD/MMM/YYYY")
                                    : null}
                            </td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Fc Hasta:</td>
                        </tr>
                        <tr>
                            <td className="text-uppercase">
                                {" "}
                                {poliza.fcHasta
                                    ? moment(poliza.fcHasta).locale("moment/locale/es").local().format("DD/MMM/YYYY")
                                    : null}
                            </td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Prima Neta Antes de Impuestos:</td>
                        </tr>
                        <tr>
                            <td>$ {vida ? poliza.valPrima : item.totPrima}</td>
                        </tr>
                        <br />
                    </tbody>
                </table>

                <ModalPrint
                    cdCompania={poliza.cdCompania}
                    cdRamoCotizacion={item.cdRamoCotizacion}
                    cdCotizacion={vida ? poliza.cdCotizacion : item.cdCotizacion}
                    alert={this.alert.current}
                    setOpen={this.closeModal}
                    open={this.state.open}
                    pdf={this.state.pdf}
                    vam={vida}
                    aseg={this.state.aseg}
                    poliza={poliza.poliza}
                />
            </div>
        );
    }
}
